import registry from '../../../identity/agents.json';

/**
 * Agent identification in the Shell (§14.6): the same colour and icon per
 * agent as Slack, from the same canonical file (identity/agents.json at
 * the repo root, validated by mcp/src/identity). Identity, not character:
 * these signals are stable and shared; there are no per-agent personas.
 */
export interface AgentDisplay {
  displayName: string;
  color: string;
  icon: string;
}

const agents = registry.agents as Record<
  string,
  { displayName: string; color: string; icon: string }
>;

const FALLBACK: AgentDisplay = { displayName: 'Unknown agent', color: '#898781', icon: '▪️' };

export function agentDisplay(agent: string): AgentDisplay {
  const entry = agents[agent];
  return entry
    ? { displayName: entry.displayName, color: entry.color, icon: entry.icon }
    : FALLBACK;
}
